import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../../Core/Link';
import RichText, { fragment } from '../../../Core/RichText';
import { sanitizeURL } from '../../../../utils/helpers';
import IndividualBlade from '../../IndividualBlades';

import { StyledContainer, Wrapper, Heading, Questions, Ctas } from './styles';

const FAQSections = ({ data, containerClass = '' }) => {
  if (!data) return null;

  const {
    id,
    component,
    faqItems,
    subCatPageSlug,
    backgroundColor,
    title,
    ctas,
  } = data;

  const color = {
    'dark-grey': themeGet('colors.stone'),
    'default (grey)': themeGet('colors.light-grey'),
    white: themeGet('colors.white'),
  };

  return (
    <StyledContainer
      className={containerClass || component}
      backgroundColor={color[backgroundColor]}
    >
      <Wrapper key={id} className={component}>
        {title && (
          <Heading>
            <h2 className="heading-b">{ReactHtmlParser(title)}</h2>
          </Heading>
        )}
        {faqItems && (
          <Questions className="no-bullets">
            {faqItems.map(
              ({ id: faq_id, question, pageSlug, faq_sub_category }) => {
                if (!pageSlug) return null;

                const category = faq_sub_category
                  ? faq_sub_category[0].subCatPageSlug
                  : subCatPageSlug;
                const url = `/learning-hub/faqs/${sanitizeURL(
                  category,
                )}/${sanitizeURL(pageSlug)}`;
                return (
                  <li key={faq_id}>
                    <Link
                      className="faq-item-link"
                      id="faq-question-page"
                      to={url}
                    >
                      {ReactHtmlParser(question)}
                    </Link>
                  </li>
                );
              },
            )}
          </Questions>
        )}
        {ctas && (
          <Ctas>
            {ctas.map(cta => {
              if (cta.hideFrench === true) return null;
              return cta.internal.type === 'ContentfulBlade' ? (
                <IndividualBlade key={cta.id} data={cta} />
              ) : (
                <Link key={cta.id} data={cta}>
                  <RichText document={cta.label} options={fragment} />
                </Link>
              );
            })}
          </Ctas>
        )}
      </Wrapper>
    </StyledContainer>
  );
};

FAQSections.propTypes = {
  data: PropTypes.shape().isRequired,
  containerClass: PropTypes.string,
};

export default FAQSections;
